import React from 'react';
import historyImage from './image/history1.jpeg'; // Ensure the path is correct
import historyImage1 from './image/history2.jpeg';
import './history.css';

const History = () => {
  return (
    <div className="history-bg">
      {/* First Section */}
      <div className="history-container">
        {/* Left Side: Text Content */}
        <div className="text-section">
          <h1 className="history-title">NASHABANDI MANDAL <br /> BOMBAY STATE</h1>
          <p className="history-text">
            • NASHABANDI MANDAL BOMBAY STATE was formed in 1950 after the <strong>The Bombay Prohibition Act, 1949</strong> came into existence, and since then it has been working against addiction.
          </p>
        </div>

        {/* Right Side: Image */}
        <div className="image-section">
          <img src={historyImage} alt="History" className="history-image" />
        </div>
      </div>

      {/* Second Section (below the first) */}
      <div className="history-container">
        {/* Left Side: Image */}
        <div className="image-section">
          <img src={historyImage1} alt="History" className="history-image" />
        </div>

        {/* Right Side: Text Content */}
        <div className="text-section">
          <h1 className="history-title">REGISTRATION OF <br /> NASHABANDI MANDAL MAHARASHTRA STATE</h1>
          <p className="history-text">
            • NASHABANDI MANDAL MAHARASHTRA STATE was registered under the Public Societies Act 1860 on <strong>16TH OCTOBER 1958</strong>.
          </p>
        </div>
      </div>

      <p className="final-note">
        <strong>Nashabandi Mandal. Thus, the Nashabandi Mandal Maharashtra State was formed under the presidency of Shri Kedarnath.</strong>
      </p>
    </div>
  );
};

export default History;
